import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { lifecycle, compose, getContext } from 'recompose';
import _ from 'lodash';
import { IconButton, LinearProgress } from 'material-ui';
import EditIcon from 'material-ui/svg-icons/av/replay';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { SMLinkButton as SMLink } from '../../components/SMLink';
import { SOCIAL_NETWORKS, STORE_KEYS } from '../../../constants';
import { fetchSmlinks, deleteSmlink } from 'dash-front/campaign/actions/smlinks';
import { getEntities, getQueries } from 'dash-front/selectors';
import SMLinkTitle from './SMLinkTitle';
import cfg from 'cfg';

export const withSmlinks = connect(
    state => ({
        smlinks: getEntities(state)[STORE_KEYS.SMLINKS],
        smlinksPending: _.get(getQueries(state).smlinks, 'isPending'),
    }),
    {
        fetchSmlinks,
        deleteSmlink,
    },
);

const createOnEditSMLink = userId => smlink => {
    const { smtype, _id: smlinkId } = smlink;
    const { smpg } = cfg.apis;
    if (smtype === 'fb') {
        const url = `${smpg}/facebook/update?smlinkId=${smlinkId}&client=${userId}&service=any`;
        window.open(url, 'Update', 'height=500,width=700');
    } else if (smtype === 'tw') {
        const url = `${smpg}/twitter/update?smlinkId=${smlinkId}&client=${userId}&service=any`;
        window.open(url, 'Update', 'height=500,width=700');
    }
};

export const SMLinkTable = compose(
    withSmlinks,
    lifecycle({
        componentDidMount() {
            this.props.fetchSmlinks();
        },
    }),
    getContext({
        user: PropTypes.object,
    }),
)(({ smlinks, user, smlinksPending, deleteSmlink }) => {
    const items = Array.isArray(smlinks) ? smlinks : [];
    const onEdit = createOnEditSMLink(user._id);

    return (
        <div>
            {smlinksPending ? <LinearProgress /> : null}
            {items.map(link => (
                <div key={link._id} style={{ display: 'flex' }}>
                    <SMLinkTitle id={link._id} style={{ minWidth: 250 }} />
                    <IconButton tooltip="Update" onTouchTap={() => onEdit(link)}>
                        <EditIcon />
                    </IconButton>
                    <IconButton tooltip="Delete" onTouchTap={() => deleteSmlink(link.id)}>
                        <DeleteIcon />
                    </IconButton>
                </div>
            ))}
            {!smlinksPending && !items.length ? <h4 style={{ textAlign: 'center' }}>No smlinks</h4> : null}
        </div>
    );
});

export const SMLinkAddButtons = withSmlinks(
    class _SMLinkAddButtons extends React.Component {
        timeout;
        static contextTypes = {
            user: PropTypes.object.isRequired,
        };

        // Two events are sent by smpg. Filter them manually.
        updateLinks = () => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.props.fetchSmlinks();
            }, 300);
        };

        onSmlinkAdd = () => {
            this.updateLinks();
            if (this.props.onAdd) {
                this.props.onAdd();
            }
        };

        renderButtons() {
            const {
                user: { _id: id },
            } = this.context;
            const { types } = this.props;
            const items =
                Array.isArray(types) && types.length
                    ? SOCIAL_NETWORKS.filter(({ key }) => types.some(type => type === key))
                    : SOCIAL_NETWORKS;
            return items.map(network => {
                return (
                    <SMLink
                        key={network.key}
                        type={network.key}
                        title={network.label || network.title}
                        onChange={this.onSmlinkAdd}
                        address={network.getAddress(id)}
                        style={{ margin: 10 }}
                    />
                );
            });
        }

        render() {
            return <div>{this.renderButtons()}</div>;
        }
    },
);

export default () => (
    <div>
        <h4>Here you can manage your social networks</h4>
        <SMLinkAddButtons />
        <SMLinkTable />
    </div>
);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/SMLink/SMLinkManager.js
 **/